
import { format, parseISO } from 'date-fns';
import { VideoEvent } from '@/hooks/useVideoEvents';

export const groupEventsByDate = (videoEvents: VideoEvent[]) => {
  const groupedEvents: Record<string, VideoEvent[]> = {};
  
  videoEvents.forEach(event => {
    const dateStr = format(event.date, 'yyyy-MM-dd');
    if (!groupedEvents[dateStr]) {
      groupedEvents[dateStr] = [];
    }
    groupedEvents[dateStr].push(event);
  });
  
  // Sort dates
  const sortedDates = Object.keys(groupedEvents).sort((a, b) => {
    return parseISO(a).getTime() - parseISO(b).getTime();
  });
  
  return { groupedEvents, sortedDates };
};
